<template>
  <v-dialog ref="dialog"
            v-model="modal"
            :return-value.sync="time"
            persistent
            lazy
            full-width
            width="290px">

    <template v-slot:activator="{ on }">
      <v-text-field v-model="time"
                    :label="label"
                    prepend-icon="access_time"
                    readonly
                    :hint="hint"
                    persistent-hint
                    v-on="on"></v-text-field>
    </template>

    <v-time-picker v-if="modal" v-model="time" @input="save" full-width>
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="modal = false">{{ $t('cancel') }}</v-btn>
      <v-btn flat color="primary" @click="$refs.dialog.save(time)">{{ $t('ok') }}</v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
export default {
  name: 'TimeDialogComp',

  props: {
    defaultTime: {
      type: String
    },

    label: {
      type: String,
      default: ''
    },

    hint: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      time: this.defaultTime,
      modal: false
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    save () {
      this.$emit('onSelectTime', this.time)
    }
  },

  watch: {
    defaultTime () {
      this.time = this.defaultTime
    }
  },

  async mounted () {
  }
}
</script>
